import React from 'react';
import { motion } from 'framer-motion';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ScheduleMarquee } from '../components/ScheduleMarquee';
import { PricingCards } from '../components/PricingCards';
import { StageFooter } from '../components/StageFooter';
export function DanceStudioPage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.6
  }} className="min-h-screen w-full bg-black text-white overflow-x-hidden" data-id="element-165">
      {/* Navigation */}
      <motion.nav initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="fixed top-0 left-0 right-0 z-50 px-6 py-6" data-id="element-166">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-167">
          {/* Logo */}
          <a href="#" className="font-display text-xl font-bold tracking-tight" data-id="element-168">
            MOVE<span className="text-white/30 italic" data-id="element-169">.</span>
          </a>

          {/* Nav links - desktop */}
          <div className="hidden md:flex items-center gap-8" data-id="element-170">
            {['Classes', 'Schedule', 'Instructors', 'Pricing'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="text-white/60 hover:text-white text-sm tracking-wider uppercase transition-colors duration-300" data-id="element-171">
                {item}
              </a>)}
          </div>

          {/* CTA */}
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="px-6 py-2 bg-[#DC2626] text-white text-xs tracking-wider uppercase hover:bg-[#b91c1c] transition-colors duration-300" data-id="element-172">
            Book Trial
          </motion.button>
        </div>
      </motion.nav>

      {/* Main content */}
      <main data-id="element-173">
        <HeroSection data-id="element-174" />
        <AboutSection data-id="element-175" />
        <ScheduleMarquee data-id="element-176" />
        <PricingCards data-id="element-177" />
      </main>

      <StageFooter data-id="element-178" />
    </motion.div>;
}